import { render, staticRenderFns } from "./normalization.vue?vue&type=template&id=671fd90c&"
import script from "./normalization.vue?vue&type=script&lang=js&"
export * from "./normalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports